import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { NavItem, NavDropdownGroup } from "./Header";

export interface MobileNavigationProps {
  navigation: NavItem[];
  dropdowns: NavDropdownGroup[];
  showDemo: boolean;
  ctaText: string;
  ctaHref: string;
  LanguageSelectorComponent?: React.FC;
  onClose: () => void;
}

export const MobileNavigation: React.FC<MobileNavigationProps> = ({
  navigation,
  dropdowns,
  showDemo,
  ctaText: _ctaText,
  ctaHref: _ctaHref,
  LanguageSelectorComponent,
  onClose,
}) => {
  const location = useLocation();
  const { t } = useTranslation();

  const isActive = (path: string) => location.pathname === path;

  const linkClass = (active: boolean) =>
    `block px-4 py-3 text-sm font-mono uppercase tracking-wider transition-all duration-200 ${
      active
        ? "text-wizard-accent-purple bg-wizard-accent-purple/10"
        : "text-wizard-text-secondary hover:text-wizard-accent-purple hover:bg-white/5"
    }`;

  return (
    <div className="md:hidden py-2 border-t border-wizard-border-secondary animate-fade-in-up">
      <nav className="flex flex-col">
        {navigation.map((item) => (
          <Link
            key={item.name}
            to={item.href}
            className={linkClass(isActive(item.href))}
            onClick={onClose}
          >
            {item.name}
          </Link>
        ))}

        {dropdowns.map((dropdown) => (
          <div key={dropdown.label}>
            <div className="px-4 pt-4 pb-2 border-t border-wizard-border-secondary mt-1">
              <span className="text-xs font-mono text-wizard-text-muted uppercase tracking-widest">
                {dropdown.label}
              </span>
            </div>
            {dropdown.items.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={linkClass(isActive(item.href))}
                style={{ paddingLeft: "1.5rem" }}
                onClick={onClose}
              >
                {item.name}
              </Link>
            ))}
          </div>
        ))}

        {showDemo && (
          <Link to="/demo/live" className={linkClass(false)} onClick={onClose}>
            {t("nav.demo", { defaultValue: "Demo" })}
          </Link>
        )}
      </nav>

      {LanguageSelectorComponent && (
        <div className="mt-3 pt-3 px-4 border-t border-wizard-border-secondary">
          <LanguageSelectorComponent />
        </div>
      )}
    </div>
  );
};

export default MobileNavigation;
